<template>
  <v-row>
    <v-col cols="12">
      <gg-loading :loading="loading" type="table">
        <hosting-ip-addr-table />
      </gg-loading>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
import HostingIpAddrTable from '@/components/Services/Hosting/HostingIpAddrTable'

export default {
  name: 'HostingIpAddr',
  components: {
    HostingIpAddrTable,
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(['hosting_detail']),
    isDataAvailable () {
      if (this.hosting_detail !== null) {
        if (this.hosting_detail.ips) {
          return true
        }
      } else {
        return false
      }
      return false
    }
  },
}
</script>
